<template>
  <div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-sm-12 mx-auto mb-3">
          <h1 class="text-center  " :class="'text-primary'">Sign up</h1>
        </div>
        <div class="col-lg-9 mx-auto">
          <div class="row">
            <div class="col-lg-6 mx-auto">
              <div class="card mb-3">
                <div class="card-body">
                  <SignupBox signup-text="Sign up" />
                </div>
              </div>
              <p>
                <router-link to="/forgot" class="btn btn-link">Forgot my password</router-link> <br>
                <router-link to="/login" class="btn btn-link">Log in</router-link> <br>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignupBox from '@/components/SignupBox.vue';

export default {
  name: 'signup',
  components: {
    SignupBox,
  },
};
</script>
